module.exports = __webpack_public_path__ + "files/dbab73037f73345cc1dac399a3ff4a8a.svg";